<script setup>
// QuizzesShell — the "Voice Quiz" category. Demonstrates the two-level
// navigation pattern: the consumer sidebar selects this category, and the
// top-tab strip (PageTabs) selects which sub-view we're on inside it.
//
// This shell is the demo proof that BaseShell + PageTabs handle the pattern
// the user asked for ("side menu for categories + top menu for category
// detail tabs"). The actual voice-loop code is NOT being rewritten here —
// it stays as the vanilla client at `/` until a deliberate migration ticket.
// These tabs are intentionally minimal scaffolds.
import { computed } from "vue";
import PageTabs from "@digitalstreams/saas-core/vue/layouts/PageTabs.vue";
import { useAuthStore } from "@digitalstreams/saas-core/vue/stores/authStore";

const auth = useAuthStore();

// History + Stats are personal data — only for signed-in users. Anonymous
// visitors (the public demo) get Choose-a-topic + Map.
const tabs = computed(() => {
  const t = [
    { label: "Choose a topic", to: "/topics",     icon: "bi bi-collection", exact: true },
    { label: "Map",            to: "/topics/map", icon: "bi bi-diagram-3" }
  ];
  if (auth.isLoggedIn) {
    t.push(
      { label: "History", to: "/topics/history", icon: "bi bi-clock-history" },
      { label: "Stats",   to: "/topics/stats",   icon: "bi bi-bar-chart" }
    );
  }
  return t;
});
</script>

<template>
  <div class="container-fluid p-0">
    <h1 class="h3 mb-1">Topics</h1>
    <p class="text-muted mb-3">
      Speak your answers. Two attempts per question, then a reveal.
    </p>

    <PageTabs :tabs="tabs" />

    <router-view />
  </div>
</template>
